import React from 'react';

export default function GuardRail({ className }) {
    return (
        <svg className={`${className}  w-8 h-8`} fill="#e20303" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            {/* Horizontal rails */}
            <rect x="2" y="4" width="20" height="2"/>
            <rect x="2" y="11" width="20" height="2"/>
            <rect x="2" y="18" width="20" height="2"/>
            
            {/* Vertical posts */}
            <rect x="4" y="2" width="3" height="20"/>
            <rect x="11" y="2" width="3" height="20"/>
            <rect x="18" y="2" width="3" height="20"/>
        </svg>
    );
}